import React from "react";

import { Card } from "affinityUI/elements/card";
import { Layout } from "affinityUI/structures/layout";

export const CookiePolicyPage: React.FC = () => {
  return (
    <Layout title="Cookie Policy" showBackBtn backLink="..">
      <Card>
        <h2>Entia Ltd&rsquo;s Cookie Policy</h2>
        <p>
          Entia Ltd through our website and our third-party providers set and use cookies to store and manage user
          preferences, enable content, gather analytic and usage data, and generally improve your user experience.
        </p>
        <p>
          This policy sets out what type of cookies we use, how we use them, and how you can control and manage them.
        </p>
        <h3>What is a cookie?</h3>
        <p>
          A cookie is a small text file that is placed on a computer or other device and is used to identify the user or
          device and to collect information. Cookies are typically assigned to one of four categories, depending on
          their function and intended purpose: strictly necessary cookies, performance cookies, functional cookies, and
          cookies for targeting and advertising purposes.
        </p>
        <h3>Types of cookies and why we use them</h3>
        <h4>Strictly necessary cookies</h4>
        <p>
          These cookies are necessary for the website to function and cannot be switched off in our systems. Without
          these cookies, services you have asked for, like adding items to the shopping basket, logging in or filling in
          forms cannot be provided. You can set your browser to block or alert you about these cookies, but some parts
          of our website will not then work. These cookies do not store any personally identifiable information.
        </p>
        <h4>Performance cookies</h4>
        <p>
          These cookies allow us to count visits and traffic sources so we can measure and improve the performance of
          our site. They help us to know which pages are the most and least popular, see how visitors move around the
          site, and whether they clicked on a link. This lets us know where we are doing well, and where we can improve,
          as well as making sure the pages load quickly and display properly. Information collected includes, for
          example, the Internet browsers and operating systems used, the domain name of the website previously visited,
          the number of visits, average duration of visit, and pages viewed. All information these cookies collect is
          aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited
          our website, and will not be able to monitor its performance and enhance your experience. We use services from
          Google, HubSpot to perform these functions.
        </p>
        <h4>Functionality cookies</h4>
        <p>
          These cookies enable the website to provide enhanced functionality and personalisation by remembering choices
          you make (such as your username or ID, language preference, or the area or region you are in). They may also
          be used to provide services you have asked for, such as watching a video. They may be set by us or by third
          party providers whose services we have added to our pages. The information these cookies collect may be
          anonymised, and they cannot track your browsing activity on other websites. If you do not allow these cookies
          then some or all of these services may not function properly.
        </p>
        <h4>Targeting and advertising cookies</h4>
        <p>
          These cookies track browsing habits and are used to deliver targeted (interest-based) advertising. These
          cookies may be set through our site by our advertising partners with our permission. They may be used by those
          companies to build a profile of your interests and show you relevant adverts on other sites. They remember
          that you have visited a website and this information is shared with other organizations, such as advertisers.
          They do not store directly personal information, but are based on uniquely identifying your browser and
          internet device. You can opt out of these cookies and continue to use Entia Ltd&rsquo;s websites.
        </p>
        <h3>Managing cookies</h3>
        <h4>Website cookies</h4>
        <p>
          You can manage website cookies in your browser settings, and you always have the choice to change these
          settings by accepting, rejecting, or deleting cookies. If you choose to change your settings, you may find
          that certain functions and features will not work as intended to avail of the Entia Ltd services. All browser
          settings are slightly different, so to manage cookies, you should refer to the relevant settings within your
          browser.
        </p>
        <p>
          Where you give consent to the use of cookies, that consent can be withdrawn at any time by adjusting your
          cookie settings. If you want to know more about cookies, please visit the following websites, which include
          detailed information about types of cookies, how they are used, and how you can manage your cookie
          preferences:
        </p>
        <p>
          <a href="http://www.cookiepedia.co.uk/index.php?title=How_to_Manage_Cookies" target="_blank" rel="noreferrer">
            http://www.cookiepedia.co.uk/index.php?title=How_to_Manage_Cookies
          </a>
        </p>
        <p>
          <a href="http://www.aboutcookies.org/" target="_blank" rel="noreferrer">
            http://www.aboutcookies.org/
          </a>
        </p>
        <p>
          Please also click below for detailed information on how to disable and delete cookies in some commonly used
          browsers:
        </p>
        <p>
          <a
            href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=en-US"
            target="_blank"
            rel="noreferrer"
          >
            Mozilla Firefox&reg;
          </a>
        </p>
        <p>
          <a
            href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11"
            target="_blank"
            rel="noreferrer"
          >
            Microsoft&reg; Internet Explorer
          </a>
        </p>
        <p>
          <a href="https://support.google.com/accounts/answer/61416?hl=en" target="_blank" rel="noreferrer">
            Google Chrome&trade;
          </a>
        </p>
        <p>
          <a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">
            Safari&reg;
          </a>
        </p>
      </Card>
    </Layout>
  );
};
